import { Box } from '@chakra-ui/react';

const PersBug = ({ bugIndex, illuminated }) => {
  // let bgGradient = null;
  let bgColor = 'GRAY_2';
  if (bugIndex === 0 && illuminated === 0) {
    bgColor = 'GRAY_2';
  }
  if (illuminated < bugIndex) {
    bgColor = null;
  } else {
  }
  return (
    <Box
      bgColor={bgColor}
      // bgGradient={bgGradient}
      sx={{
        border: '6px solid',
        borderColor: 'WHITE',
        padding: 0,
        margin: '-3px',
        minHeight: '20px',
        flex: 1,
        borderRadius: '10px',
      }}
    />
  );
};
export default PersBug;
